{
  "familyId": "GET-VERGELIJK",
  "questions": [
    {
      "id": "GET-VERGELIJK-001",
      "familyId": "GET-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_vergelijken",
      "questionType": "multiple_choice",
      "question": "Welke breuk is het grootst: $\\frac{2}{5}$ of $\\frac{3}{5}$?",
      "options": [
        "$\\frac{3}{5}$",
        "$\\frac{2}{5}$",
        "ze zijn even groot",
        "dat kun je niet vergelijken"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 2,
            "denominator": 5,
            "label": "$\\frac{2}{5}$",
            "visualType": "bar",
            "showEaten": false
          }
        },
        {
          "type": "fraction",
          "data": {
            "numerator": 3,
            "denominator": 5,
            "label": "$\\frac{3}{5}$",
            "visualType": "bar",
            "showEaten": false
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gelijknamige breuken vergelijken",
            "content": "De getallen onder de streep zijn gelijk (beide 5). Vergelijk dan alleen de getallen boven de streep. Meer stukken van dezelfde grootte = grotere breuk. 3 > 2, dus $\\frac{3}{5}$ > $\\frac{2}{5}$.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_vergelijk_gelijknamig",
      "variantIndex": 1,
      "citoDifficulty": 0.22,
      "citoDiscrimination": 0.76,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Beide breuken hebben hetzelfde getal onder de streep (5). Vergelijk dan de getallen boven de streep: 3 > 2. Meer stukken van dezelfde grootte = groter. Dus $\\frac{3}{5}$ > $\\frac{2}{5}$.",
        "solutionSteps": [
          "Kijk naar het getal onder de streep: beide zijn 5",
          "Vergelijk de getallen boven de streep: 3 en 2",
          "3 > 2, dus $\\frac{3}{5}$ > $\\frac{2}{5}$"
        ],
        "distractorExplanations": {
          "0": "Goed! Bij hetzelfde getal onder de streep is de breuk met het grootste getal boven de streep het grootst: 3 > 2, dus $\\frac{3}{5}$ > $\\frac{2}{5}$.",
          "1": "Je dacht dat minder stukken groter is. Maar bij hetzelfde getal onder de streep geldt: meer stukken = groter. 3 stukken van vijfde > 2 stukken van vijfde.",
          "2": "Ze zijn niet even groot. $\\frac{3}{5}$ heeft 3 stukken en $\\frac{2}{5}$ heeft 2 stukken van dezelfde grootte. 3 ≠ 2.",
          "3": "Je kunt ze wél vergelijken! Omdat het getal onder de streep gelijk is (beide 5), vergelijk je gewoon de getallen boven de streep."
        }
      }
    },
    {
      "id": "GET-VERGELIJK-002",
      "familyId": "GET-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_vergelijken",
      "questionType": "multiple_choice",
      "question": "Welke breuk is het grootst: $\\frac{1}{3}$ of $\\frac{1}{6}$?",
      "options": [
        "$\\frac{1}{3}$",
        "$\\frac{1}{6}$",
        "ze zijn even groot",
        "$\\frac{1}{6}$ want 6 > 3"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 3,
            "label": "$\\frac{1}{3}$",
            "visualType": "bar",
            "showEaten": false
          }
        },
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 6,
            "label": "$\\frac{1}{6}$",
            "visualType": "bar",
            "showEaten": false
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Eenheidsbreuken vergelijken",
            "content": "De getallen boven de streep zijn gelijk (beide 1). Hoe meer stukken een geheel verdeeld is, hoe kleiner elk stuk. 3 stukken zijn groter dan 6 stukken, dus $\\frac{1}{3}$ > $\\frac{1}{6}$.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_vergelijk_noemer",
      "variantIndex": 2,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.7,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Beide breuken hebben hetzelfde getal boven de streep (1). Meer stukken = elk stuk kleiner. $\\frac{1}{3}$ heeft 3 stukken, $\\frac{1}{6}$ heeft 6 stukken. 3 stukken zijn groter dan 6 stukken. Dus $\\frac{1}{3}$ > $\\frac{1}{6}$.",
        "solutionSteps": [
          "Kijk naar het getal boven de streep: beide zijn 1",
          "Vergelijk het getal onder de streep: 3 en 6",
          "Meer stukken = elk stuk kleiner",
          "$\\frac{1}{3}$ heeft 3 stukken → groter dan $\\frac{1}{6}$ met 6 stukken"
        ],
        "distractorExplanations": {
          "0": "Goed! Bij hetzelfde getal boven de streep geldt: minder stukken = groter stuk. $\\frac{1}{3}$ > $\\frac{1}{6}$ want 3 stukken zijn groter dan 6 stukken.",
          "1": "Je dacht dat een groter getal onder de streep een grotere breuk betekent. Maar het tegenovergestelde is waar! Meer stukken = elk stuk kleiner.",
          "2": "Ze zijn niet even groot. $\\frac{1}{3}$ is groter: als je een taart in 3 stukken snijdt, is elk stuk groter dan als je dezelfde taart in 6 stukken snijdt.",
          "3": "Je hebt alleen naar de getallen gekeken (6 > 3). Maar bij breuken werkt het andersom: meer stukken = elk stuk kleiner. Denk aan een taart: 6 stukken zijn kleiner dan 3 stukken."
        }
      }
    },
    {
      "id": "GET-VERGELIJK-003",
      "familyId": "GET-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_vergelijken",
      "questionType": "multiple_choice",
      "question": "Zet het juiste teken: $\\frac{4}{7}$ ○ $\\frac{5}{7}$",
      "options": [
        "<",
        ">",
        "=",
        "≠"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 4,
            "denominator": 7,
            "label": "$\\frac{4}{7}$",
            "visualType": "bar",
            "showEaten": false
          }
        },
        {
          "type": "fraction",
          "data": {
            "numerator": 5,
            "denominator": 7,
            "label": "$\\frac{5}{7}$",
            "visualType": "bar",
            "showEaten": false
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vergelijkingsteken kiezen",
            "content": "Gelijke noemer (7) → vergelijk de tellers. 4 < 5 betekent: $\\frac{4}{7}$ is kleiner dan $\\frac{5}{7}$. Het teken < wijst altijd naar het kleinste getal.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_vergelijk_teken",
      "variantIndex": 3,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Beide breuken hebben hetzelfde getal onder de streep (7). Vergelijk de getallen boven de streep: 4 en 5. 4 < 5, dus $\\frac{4}{7}$ < $\\frac{5}{7}$.",
        "solutionSteps": [
          "Kijk naar het getal onder de streep: beide zijn 7",
          "Vergelijk de getallen boven de streep: 4 en 5",
          "4 < 5, dus $\\frac{4}{7}$ < $\\frac{5}{7}$"
        ],
        "distractorExplanations": {
          "0": "Goed! 4 < 5, dus $\\frac{4}{7}$ < $\\frac{5}{7}$. Bij hetzelfde getal onder de streep vergelijk je de getallen boven de streep.",
          "1": "Je hebt het teken omgedraaid. 4 < 5, niet 4 > 5. Dus $\\frac{4}{7}$ is kleiner dan $\\frac{5}{7}$.",
          "2": "Ze zijn niet gelijk. $\\frac{4}{7}$ ≠ $\\frac{5}{7}$ want de getallen boven de streep zijn verschillend (4 ≠ 5).",
          "3": "Het teken ≠ (niet gelijk aan) klopt wel, maar is niet het meest precieze antwoord. We kunnen precies zeggen welke groter is: $\\frac{4}{7}$ < $\\frac{5}{7}$."
        }
      }
    },
    {
      "id": "GET-VERGELIJK-004",
      "familyId": "GET-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_vergelijken",
      "questionType": "multiple_choice",
      "question": "Welke breuk is het kleinst: $\\frac{1}{4}$, $\\frac{1}{2}$ of $\\frac{1}{8}$?",
      "options": [
        "$\\frac{1}{8}$",
        "$\\frac{1}{4}$",
        "$\\frac{1}{2}$",
        "ze zijn even groot"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 4,
            "label": "$\\frac{1}{4}$",
            "visualType": "bar",
            "showEaten": false
          }
        },
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 2,
            "label": "$\\frac{1}{2}$",
            "visualType": "bar",
            "showEaten": false
          }
        },
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 8,
            "label": "$\\frac{1}{8}$",
            "visualType": "bar",
            "showEaten": false
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Eenheidsbreuken ordenen",
            "content": "Alle tellers zijn 1. Bij gelijke teller: hoe groter de noemer, hoe kleiner het stuk. Noemers 2, 4, 8 → stukken worden steeds kleiner. Dus $\\frac{1}{8}$ is het kleinst.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_vergelijk_drie",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.71,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Alle breuken hebben hetzelfde getal boven de streep (1). Meer stukken = elk stuk kleiner. Vergelijk de getallen onder de streep: 4, 2 en 8. De grootste (8) geeft het kleinste stuk. Dus $\\frac{1}{8}$ is het kleinst. Volgorde: $\\frac{1}{8}$ < $\\frac{1}{4}$ < $\\frac{1}{2}$.",
        "solutionSteps": [
          "Kijk naar het getal boven de streep: alle zijn 1",
          "Meer stukken = elk stuk kleiner",
          "Vergelijk de getallen onder de streep: 4, 2 en 8",
          "De grootste (8) geeft het kleinste stuk: $\\frac{1}{8}$ is het kleinst"
        ],
        "distractorExplanations": {
          "0": "Goed! $\\frac{1}{8}$ is het kleinst. Hoe meer stukken je maakt, hoe kleiner elk stuk wordt. 8 stukken → kleinste stukken.",
          "1": "$\\frac{1}{4}$ is niet het kleinst. $\\frac{1}{8}$ is kleiner, want 8 stukken zijn kleiner dan 4 stukken.",
          "2": "$\\frac{1}{2}$ is juist het grootst! Een half is groter dan een kwart en groter dan een achtste.",
          "3": "Ze zijn niet even groot. $\\frac{1}{2}$ > $\\frac{1}{4}$ > $\\frac{1}{8}$. Meer stukken = elk stuk kleiner."
        }
      }
    },
    {
      "id": "GET-VERGELIJK-005",
      "familyId": "GET-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_vergelijken",
      "questionType": "multiple_choice",
      "question": "Welke breuk is groter dan $\\frac{1}{2}$?",
      "options": [
        "$\\frac{3}{4}$",
        "$\\frac{1}{3}$",
        "$\\frac{2}{5}$",
        "$\\frac{1}{4}$"
      ],
      "correctAnswer": 0,
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 2,
            "label": "$\\frac{1}{2}$ (de helft)",
            "visualType": "bar",
            "showEaten": false
          }
        }
      ],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Vergelijken met $\\frac{1}{2}$ als ijkpunt",
            "content": "Een breuk is groter dan $\\frac{1}{2}$ als de teller meer is dan de helft van de noemer. $\\frac{3}{4}$: 3 > helft van 4 (=2) → groter dan $\\frac{1}{2}$. $\\frac{1}{3}$, $\\frac{2}{5}$, $\\frac{1}{4}$: teller < helft van noemer → kleiner.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_vergelijk_benchmark",
      "variantIndex": 5,
      "citoDifficulty": 0.4,
      "citoDiscrimination": 0.69,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Vergelijk elke breuk met $\\frac{1}{2}$ (de helft). $\\frac{3}{4}$ = 3 van de 4 stukken = meer dan de helft ✓. $\\frac{1}{3}$ = 1 van de 3 stukken = minder dan de helft ✗. $\\frac{2}{5}$ = 2 van de 5 stukken = minder dan de helft ✗. Alleen $\\frac{3}{4}$ is groter dan $\\frac{1}{2}$.",
        "solutionSteps": [
          "Vergelijk elke breuk met $\\frac{1}{2}$ (de helft)",
          "$\\frac{3}{4}$: 3 van de 4 stukken = meer dan de helft ✓",
          "$\\frac{1}{3}$, $\\frac{2}{5}$, $\\frac{1}{4}$: allemaal minder dan de helft ✗",
          "Alleen $\\frac{3}{4}$ is groter dan $\\frac{1}{2}$"
        ],
        "distractorExplanations": {
          "0": "Goed! $\\frac{3}{4}$ = 0,75 en $\\frac{1}{2}$ = 0,5. Drie kwart is meer dan de helft.",
          "1": "$\\frac{1}{3}$ ≈ 0,33, dat is minder dan $\\frac{1}{2}$ = 0,5. Eén derde is minder dan de helft.",
          "2": "$\\frac{2}{5}$ = 0,4, dat is minder dan $\\frac{1}{2}$ = 0,5. Twee vijfde is net iets minder dan de helft.",
          "3": "$\\frac{1}{4}$ = 0,25, dat is minder dan $\\frac{1}{2}$ = 0,5. Een kwart is de helft van een half."
        }
      }
    },
    {
      "id": "GET-VERGELIJK-006",
      "familyId": "GET-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_vergelijken",
      "questionType": "ordering",
      "question": "Zet deze breuken op volgorde van klein naar groot.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["$\\frac{4}{7}$", "$\\frac{1}{7}$", "$\\frac{6}{7}$", "$\\frac{3}{7}$"],
        "correctOrder": [1, 3, 0, 2]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 4,
            "denominator": 7,
            "fractions": [
              {"numerator": 1, "denominator": 7, "label": "1/7"},
              {"numerator": 3, "denominator": 7, "label": "3/7"},
              {"numerator": 4, "denominator": 7, "label": "4/7"},
              {"numerator": 6, "denominator": 7, "label": "6/7"}
            ],
            "visualType": "bar"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Gelijknamige breuken ordenen",
            "content": "Als het getal onder de streep hetzelfde is, vergelijk je de getallen boven de streep. Hoe groter het getal boven de streep, hoe groter de breuk.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_ordenen_gelijknamig",
      "variantIndex": 6,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.73,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Alle breuken hebben hetzelfde getal onder de streep (7). Vergelijk de getallen boven de streep: 1 < 3 < 4 < 6. Dus de volgorde is: $\\frac{1}{7}$ < $\\frac{3}{7}$ < $\\frac{4}{7}$ < $\\frac{6}{7}$.",
        "solutionSteps": [
          "Alle getallen onder de streep zijn gelijk: 7",
          "Vergelijk de getallen boven de streep: 1, 3, 4, 6",
          "Volgorde: 1 < 3 < 4 < 6",
          "$\\frac{1}{7}$ < $\\frac{3}{7}$ < $\\frac{4}{7}$ < $\\frac{6}{7}$"
        ]
      }
    },
    {
      "id": "GET-VERGELIJK-007",
      "familyId": "GET-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_vergelijken",
      "questionType": "ordering",
      "question": "Zet deze breuken op volgorde van groot naar klein.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["$\\frac{1}{2}$", "$\\frac{1}{8}$", "$\\frac{1}{4}$", "$\\frac{1}{6}$"],
        "correctOrder": [0, 2, 3, 1]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Eenheidsbreuken ordenen",
            "content": "Bij breuken met hetzelfde getal boven de streep (1) geldt: hoe groter het getal onder de streep, hoe kleiner de breuk. Meer stukken = elk stuk kleiner. Dus $\\frac{1}{2}$ > $\\frac{1}{4}$ > $\\frac{1}{6}$ > $\\frac{1}{8}$.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_ordenen_eenheidsbreuken",
      "variantIndex": 7,
      "citoDifficulty": 0.40,
      "citoDiscrimination": 0.70,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Alle getallen boven de streep zijn 1. Bij eenheidsbreuken geldt: hoe groter het getal onder de streep, hoe kleiner de breuk. De getallen onder de streep zijn 2, 4, 6, 8. Van groot naar klein: $\\frac{1}{2}$ > $\\frac{1}{4}$ > $\\frac{1}{6}$ > $\\frac{1}{8}$.",
        "solutionSteps": [
          "Alle getallen boven de streep zijn 1 (eenheidsbreuken)",
          "Groter getal onder de streep = kleiner stuk",
          "Getallen onder de streep van klein naar groot: 2, 4, 6, 8",
          "Van groot naar klein: $\\frac{1}{2}$ > $\\frac{1}{4}$ > $\\frac{1}{6}$ > $\\frac{1}{8}$"
        ]
      }
    },
    {
      "id": "GET-VERGELIJK-008",
      "familyId": "GET-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_vergelijken",
      "questionType": "ordering",
      "question": "Zet deze breuken op volgorde van klein naar groot. Tip: vergelijk ze met $\\frac{1}{2}$.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["$\\frac{3}{4}$", "$\\frac{1}{4}$", "$\\frac{2}{4}$"],
        "correctOrder": [1, 2, 0]
      },
      "stimulusAids": [
        {
          "type": "fraction",
          "data": {
            "numerator": 1,
            "denominator": 2,
            "label": "Benchmark: $\\frac{1}{2}$",
            "visualType": "bar",
            "showEaten": false
          }
        }
      ],
      "supportAids": [
        {
          "type": "fraction",
          "showWhen": "wrong",
          "data": {
            "numerator": 2,
            "denominator": 4,
            "fractions": [
              {"numerator": 1, "denominator": 4, "label": "1/4"},
              {"numerator": 2, "denominator": 4, "label": "2/4"},
              {"numerator": 3, "denominator": 4, "label": "3/4"}
            ],
            "visualType": "bar"
          }
        },
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Breuken ordenen met benchmark",
            "content": "Gebruik $\\frac{1}{2}$ als hulpmiddel. $\\frac{1}{4}$ < $\\frac{1}{2}$, $\\frac{2}{4}$ = $\\frac{1}{2}$, $\\frac{3}{4}$ > $\\frac{1}{2}$. Dus: $\\frac{1}{4}$ < $\\frac{2}{4}$ < $\\frac{3}{4}$.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "breuk_ordenen_benchmark",
      "variantIndex": 8,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Alle breuken hebben hetzelfde getal onder de streep (4). Vergelijk de getallen boven de streep: 1 < 2 < 3. Dus $\\frac{1}{4}$ < $\\frac{2}{4}$ < $\\frac{3}{4}$. Check met benchmark: $\\frac{2}{4}$ = $\\frac{1}{2}$ ✓.",
        "solutionSteps": [
          "Alle getallen onder de streep zijn 4",
          "Vergelijk de getallen boven de streep: 1 < 2 < 3",
          "$\\frac{1}{4}$ < $\\frac{2}{4}$ < $\\frac{3}{4}$",
          "Check: $\\frac{2}{4}$ = $\\frac{1}{2}$ ✓"
        ]
      }
    },
    {
      "id": "GET-VERGELIJK-009",
      "familyId": "GET-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_vergelijken",
      "questionType": "multiple_choice",
      "question": "Bekijk de breukenstroken. Welke breuk is het grootst?",
      "context": null,
      "options": [
        "$\\frac{3}{4}$",
        "$\\frac{2}{3}$",
        "ze zijn even groot",
        "dat kun je niet zien"
      ],
      "correctAnswer": 0,
      "conceptId": "breuk_vergelijk_strip_ongelijknamig",
      "variantIndex": 9,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.74,
      "stimulusAids": [
        {
          "type": "fractionStrip",
          "data": {
            "fractions": [
              { "numerator": 3, "denominator": 4, "label": "¾" },
              { "numerator": 2, "denominator": 3, "label": "⅔" }
            ],
            "label": "Vergelijk de twee breuken"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fractionStrip",
          "showWhen": "wrong",
          "data": {
            "fractions": [
              { "numerator": 3, "denominator": 4, "label": "¾ = 75%" },
              { "numerator": 2, "denominator": 3, "label": "⅔ ≈ 67%" }
            ],
            "label": "¾ is groter dan ⅔",
            "highlightIndex": 0
          }
        }
      ],
      "feedback": {
        "explanationText": "Kijk naar de stroken: de bovenste ($\\frac{3}{4}$) is verder gevuld dan de onderste ($\\frac{2}{3}$). Je kunt het ook berekenen: $\\frac{3}{4}$ = 0,75 en $\\frac{2}{3}$ ≈ 0,667. Dus $\\frac{3}{4}$ > $\\frac{2}{3}$.",
        "solutionSteps": [
          "Bekijk de stroken: welke is verder gevuld?",
          "De bovenste strook ($\\frac{3}{4}$) is meer gevuld",
          "Check: $\\frac{3}{4}$ = 0,75 en $\\frac{2}{3}$ ≈ 0,667",
          "$\\frac{3}{4}$ > $\\frac{2}{3}$ ✓"
        ],
        "distractorExplanations": {
          "0": "Goed! De strook van $\\frac{3}{4}$ is verder gevuld. $\\frac{3}{4}$ = 75% > $\\frac{2}{3}$ ≈ 67%.",
          "1": "Kijk goed naar de stroken: $\\frac{2}{3}$ is minder ver gevuld dan $\\frac{3}{4}$. $\\frac{2}{3}$ ≈ 67% < 75% = $\\frac{3}{4}$.",
          "2": "Ze zijn niet even groot. De stroken laten duidelijk zien dat $\\frac{3}{4}$ meer gevuld is dan $\\frac{2}{3}$.",
          "3": "Je kunt het wél zien! Vergelijk hoe ver de gekleurde delen gaan. De langere strook hoort bij de grotere breuk."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "get.fraction-compare-wrong-pick", "label": "Kleinere breuk als grootste gekozen", "optionIndex": 1 },
          { "id": "get.fraction-compare-equal-error", "label": "Ongelijke breuken als gelijk beoordeeld", "optionIndex": 2 },
          { "id": "get.fraction-compare-give-up", "label": "Denkt dat ongelijknamig niet vergelijkbaar is", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "GET-VERGELIJK-010",
      "familyId": "GET-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_vergelijken",
      "questionType": "comparison_judge",
      "question": "Welke breuk is groter? Gebruik de breukenstroken als hulpmiddel.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": [
          { "id": "a", "content": "$\\frac{5}{6}$", "label": "Breuk A" },
          { "id": "b", "content": "$\\frac{3}{4}$", "label": "Breuk B" }
        ],
        "criterion": "Welke is groter?",
        "correctIndex": 0
      },
      "conceptId": "breuk_vergelijk_judge_ongelijknamig",
      "variantIndex": 10,
      "citoDifficulty": 0.38,
      "citoDiscrimination": 0.70,
      "stimulusAids": [
        {
          "type": "fractionStrip",
          "data": {
            "fractions": [
              { "numerator": 5, "denominator": 6, "label": "Breuk A: ⅚" },
              { "numerator": 3, "denominator": 4, "label": "Breuk B: ¾" }
            ],
            "label": "Vergelijk de stroken"
          }
        }
      ],
      "supportAids": [
        {
          "type": "fractionStrip",
          "showWhen": "wrong",
          "data": {
            "fractions": [
              { "numerator": 5, "denominator": 6, "label": "⅚ ≈ 83%" },
              { "numerator": 3, "denominator": 4, "label": "¾ = 75%" }
            ],
            "label": "⅚ is groter dan ¾",
            "highlightIndex": 0
          }
        }
      ],
      "feedback": {
        "explanationText": "Kijk naar de stroken: $\\frac{5}{6}$ is verder gevuld dan $\\frac{3}{4}$. Berekening: $\\frac{5}{6}$ ≈ 0,833 en $\\frac{3}{4}$ = 0,75. Dus $\\frac{5}{6}$ > $\\frac{3}{4}$. Tip: bij beide breuken ontbreekt er maar 1 deel. Bij $\\frac{5}{6}$ ontbreekt $\\frac{1}{6}$ en bij $\\frac{3}{4}$ ontbreekt $\\frac{1}{4}$. Omdat $\\frac{1}{6}$ < $\\frac{1}{4}$, mist $\\frac{5}{6}$ minder → $\\frac{5}{6}$ is groter.",
        "solutionSteps": [
          "Bekijk de stroken: welke is verder gevuld?",
          "$\\frac{5}{6}$ mist $\\frac{1}{6}$, $\\frac{3}{4}$ mist $\\frac{1}{4}$",
          "$\\frac{1}{6}$ < $\\frac{1}{4}$, dus $\\frac{5}{6}$ mist minder",
          "$\\frac{5}{6}$ > $\\frac{3}{4}$ ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    },
    {
      "id": "GET-VERGELIJK-011",
      "familyId": "GET-VERGELIJK",
      "module": "Getalbegrip",
      "tier": 3,
      "levelCode": "M6",
      "group": 6,
      "skill": "breuken",
      "subSkill": "breuk_vergelijken",
      "questionType": "ordering",
      "question": "Zet deze breuken op volgorde van klein naar groot.",
      "context": null,
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["$\\frac{1}{3}$", "$\\frac{1}{2}$", "$\\frac{1}{6}$", "$\\frac{1}{4}$"],
        "correctOrder": [2, 3, 0, 1]
      },
      "conceptId": "breuk_ordenen_eenheidsbreuken_strip",
      "variantIndex": 11,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "fractionStrip",
          "showWhen": "wrong",
          "data": {
            "fractions": [
              { "numerator": 1, "denominator": 6, "label": "⅙" },
              { "numerator": 1, "denominator": 4, "label": "¼" },
              { "numerator": 1, "denominator": 3, "label": "⅓" },
              { "numerator": 1, "denominator": 2, "label": "½" }
            ],
            "label": "Eenheidsbreuken: hoe groter de noemer, hoe kleiner het deel"
          }
        }
      ],
      "feedback": {
        "explanationText": "Bij eenheidsbreuken (teller = 1) geldt: hoe groter het getal onder de streep, hoe kleiner de breuk. Je deelt namelijk in meer stukken, dus elk stuk is kleiner. Volgorde: $\\frac{1}{6}$ < $\\frac{1}{4}$ < $\\frac{1}{3}$ < $\\frac{1}{2}$.",
        "solutionSteps": [
          "Alle tellers zijn 1 (eenheidsbreuken)",
          "Grotere noemer = kleinere breuk",
          "Noemers van groot naar klein: 6, 4, 3, 2",
          "Dus: $\\frac{1}{6}$ < $\\frac{1}{4}$ < $\\frac{1}{3}$ < $\\frac{1}{2}$ ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    }
  ]
}